module.exports = __webpack_public_path__ + "static/media/client1.904cfd83.png";